import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="custom-footer">
      <div className="footer-container">
        <div className="footer-column footer-contact-info">
          <img src={`${process.env.PUBLIC_URL}/assets/yrm-logo-black.png`} alt="Yellow Room Music Logo" className="footer-logo" />
          <p className="footer-email">CONTACT@ZYRIXCODE.COM</p>
          <p className="footer-phone">763-535-6202</p>
          <div className="social-icons">
            <a href="/"><i className="fab fa-facebook-f"></i></a>
            <a href="/"><i className="fab fa-twitter"></i></a>
            <a href="/"><i className="fab fa-instagram"></i></a>
            <a href="/"><i className="fab fa-linkedin-in"></i></a>
            <a href="/"><i className="fab fa-youtube"></i></a>
          </div>
        </div>

        <div className="footer-column footer-menu">
          <h4>MENU</h4>
          <ul>
            <li><a href="/">HOME</a></li>
            <li><a href="/">MENU</a></li>
            <li><a href="/">CONTACT</a></li>
          </ul>
        </div>

        <div className="footer-column footer-utility">
          <h4>POLICIES</h4>
          <ul>
            <li><a href="/">TERMS OF SERVICE</a></li>
            <li><a href="/">PRIVACY POLICY</a></li>
          </ul>
        </div>

        <div className="footer-column footer-locations">
          <h4>LOCATION</h4>
          <p><strong>Crystal, MN</strong><br />6418 Bass Lake Road<br />Crystal, MN 55428</p>
        </div>
      </div>

      <div className="footer-bottom">
      <p>
        Copyright © Cafe | Designed By{" "}
        <a href="https://zyrixtech.com" target="_blank" rel="noopener noreferrer">
          Zyrix Tech
        </a>
      </p>
    </div>
    </footer>
  );
}

export default Footer;